module.exports = __webpack_public_path__ + "static/media/ProfileIcon.43c28872.svg";